module.exports = __webpack_public_path__ + "static/media/iskrobezopasnye_promyshlennostikz.4e9b4bed.pdf";